import React from "react";
import { css, useTheme } from "@emotion/react";
import { NavLink } from "react-router-dom";
import { showPreferences } from "vanilla-cookieconsent";

import FooterLink from "core/Components/Footer/FooterLink";
import Image from "core/Components/Image";
import { useAppState } from "core/contexts/AppContext";
import { FLAG_COOKIE_SETTINGS } from "core/includes/featureFlags";

import st4sBadge from "images/badges/ST4S_Badge_2024_Colour.png";

type Props = {
    footerBottomMenu: [any] | undefined,
};

const FooterBottomSection: React.FC<Props> = ({
    footerBottomMenu,
}) => {
    const theme = useTheme();
    const [appState] = useAppState();
    const hasCookiesFeatureFlag = appState.featureFlags?.includes(FLAG_COOKIE_SETTINGS);

    const style = css`
        display: flex;
        justify-content: space-between;
        padding-top: 40px;
        width: 100%;
    `;

    const leftSectionStyle = css`
        display: flex;
        justify-content: end;
        width: 100%;
        
        ${theme.breakpoints.down("md")} {
            justify-content: start;
            flex-direction: column;
        }
    `;

    const manageCookiesStyle = css`
        ${theme.mixins.button.reset()}
        
        width: fit-content;
        font-size: ${theme.fonts.baseSize};
        cursor: pointer;
        color: ${theme.colours.grey[650]};
    `;

    const badgeImageContainerStyle = css`
        min-width: 166px;
    `;

    const badgeImageStyle = css`
        justify-self: center;
        width: 130px;
        height: 143px;
        
        ${theme.breakpoints.up('lg')} {
            display: none;
        }
    `;

    return (
        <div css={style}>
            <div css={leftSectionStyle}>
                {hasCookiesFeatureFlag && (
                    <button css={manageCookiesStyle} onClick={showPreferences}>
                        Manage Cookie Settings
                    </button>
                )}
                {footerBottomMenu?.map((menu: StandardPage) => (
                    <FooterLink key={'footer' + menu.id} isBottomMenu>
                        <NavLink to={'/' + menu.uRLSegment}>
                            {menu.titleForFooter ?? menu.title}
                        </NavLink>
                    </FooterLink>
                ))}
            </div>
            <div css={badgeImageContainerStyle}>
                <Image image={st4sBadge} css={badgeImageStyle} />
            </div>
        </div>
    );
};

export default FooterBottomSection;